import styled from 'styled-components';

import { COLOR, font, mixins } from '#@/shared/utils/styles';

interface ImageProps {
  avatarUrl: string;
  size: number;
}

export const Image = styled.div<ImageProps>`
  flex-shrink: 0;
  display: inline-block;
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
  border-radius: 100%;
  background-image: url('${(props) => props.avatarUrl}');
  ${mixins.backgroundImage()}
`;

interface LetterProps {
  color: COLOR;
  size: number;
}

export const Letter = styled.div<LetterProps>`
  flex-shrink: 0;
  position: relative;
  display: inline-block;
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
  border-radius: 100%;
  text-transform: uppercase;
  color: ${COLOR.white};
  background: ${(props) => props.color};
  ${font.medium}
  ${(props) => font.size(Math.round(props.size / 1.7))}
  & > span {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
`;

export const PinWrapper = styled.div`
  position: absolute;
  display: flex;
  bottom: -3px;
  right: -3px;
`;
